export const showSearch = () => {
  const searchMobButton = document.querySelector(".js-mob-search-btn");
  const searchMobField = document.querySelector(".js-mob-search");

  function showSearchMobField(event) {
    searchMobField.classList.add('user--show');
  }

  if (searchMobButton) {
    searchMobButton.addEventListener('click', showSearchMobField);
  }

  if (searchMobField) {
    const searchMobCloseBtn = searchMobField.querySelector(".js-mob-search-close");

    function closeSearchMobField(event) {
      searchMobField.classList.remove('user--show');
    }

    searchMobCloseBtn.addEventListener('click', closeSearchMobField);
  }
}


export const showSearchTab = () => {
  const searchTabButton = document.querySelector(".js-search-button");
  const searchTabField = document.querySelector(".js-search-field");

  function ShowSearchTabField(event) {
    searchTabField.classList.toggle('user__search-label--show');
  }

  if (searchTabButton) {
    searchTabButton.addEventListener('click', ShowSearchTabField);
  }
}